/* eslint-disable no-unreachable */
import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import DateInputPicker from 'modules/common/components/DateInputPicker';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createBirthCertificate,
  getBirthCertificateList,
  history,
  showBirthCertificate,
  getRoleList,
  creating,
}) {

  const [formData, setFormData] = useState({
    registry_number: '',
    last_name: '',
    first_name: '',
    birth_place: '',
    birth_date: '',
    mothers_last_name: '',
    mothers_first_name: '',
  });

  const commonValidation = {
    registry_number: 'required',
    last_name: 'required',
    first_name: 'required',
    birth_place: 'required',
    birth_date: 'required',
    mothers_last_name: 'required',
    mothers_first_name: 'required',
  }

  const validateForm = useFormValidator(
    formData,
    commonValidation,
  );

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const setModal = useContext(ModalContext);

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      registry_number: formData.registry_number.toUpperCase(),
      last_name: formData.last_name.toUpperCase(),
      first_name: formData.first_name.toUpperCase(),
      birth_place: formData.birth_place.toUpperCase(),
      birth_date: formData.birth_date.toUpperCase(),
      mothers_last_name: formData.mothers_last_name.toUpperCase(),
      mothers_first_name: formData.mothers_first_name.toUpperCase(),
    };

    createBirthCertificate(args, ({ data }) => {
      setModal({ isOpen: false });
      getBirthCertificateList();
      history.push(
        `/civil-registry/birth-certificate/records-maintenance/${_.get(
          data,
          'id'
        )}`
      );
      showBirthCertificate(data.id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  const handleOnSelect = (key) => e => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="">Document&apos;s Owner Personal Information</div>
        <div className="border border-primary m-1 p-1">
          <div className="row m-1 p-1">
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Registry Number &nbsp; {validateForm.renderMessage('registry_number')}
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="registry_number"
                onChange={onChange}
                value={_.get(formData, 'registry_number') || ''}
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Last Name &nbsp; {validateForm.renderMessage('last_name')}
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="last_name"
                onChange={onChange}
                value={_.get(formData, 'last_name') || ''}
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Middle Name
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="middle_name"
                onChange={onChange}
                value={_.get(formData, 'middle_name') || ''}
              />
            </div>
          </div>
          <div className="row m-1 p-1">
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                First Name &nbsp; {validateForm.renderMessage('first_name')}
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="first_name"
                onChange={onChange}
                value={_.get(formData, 'first_name') || ''}
              />
            </div>
            <div className="col-4 form-group">
              <label className="form-label mb-1">Extension Name:</label>
              <Select
                className="extension_select"
                options={c.EXTENSION_NAMES}
                onChange={handleOnSelect('extension_name')}
                value={
                  c.EXTENSION_NAMES.find(
                    x =>
                      x.value ===
                      _.get(formData, 'extension_name')
                  ) || null
                }
              />
            </div>
            <div className="col-4 form-group">
              <label htmlFor="last_name" className="form-label mb-1">
                Place of Birth &nbsp; {validateForm.renderMessage('birth_place')}
              </label>
              <input
                className="form-control text-uppercase"
                type="text"
                name="birth_place"
                onChange={onChange}
                value={_.get(formData, 'birth_place') || ''}
              />
            </div>
          </div>
          <div className="row m-1 p-1">
            <div className="col-4 form-group">
              <label className="form-control-plaintext form-label">
                Birthdate: &nbsp; {validateForm.renderMessage('birth_date')}
              </label>
              <DateInputPicker
                className="full-input"
                onChange={handleOnChangeDate('birth_date')}
                value={_.get(formData, 'birth_date') || ''}
                maxDate={new Date()}
              />
            </div>
          </div>
        </div>
        <div className="mt-3">Document&apos;s Owner Mother Information</div>
        <div className="border border-primary row m-1 p-1 mb-3">
          <div className="col-12">
            <div className="row">
              <div className="col-4 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Last Name &nbsp; {validateForm.renderMessage('mothers_last_name')}
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="mothers_last_name"
                  onChange={onChange}
                  value={_.get(formData, 'mothers_last_name') || ''}
                />
              </div>
              <div className="col-4 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  First Name &nbsp; {validateForm.renderMessage('mothers_first_name')}
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="mothers_first_name"
                  onChange={onChange}
                  value={_.get(formData, 'mothers_first_name') || ''}
                />
              </div>
              <div className="col-4 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Middle Name
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="mothers_middle_name"
                  onChange={onChange}
                  value={_.get(formData, 'mothers_middle_name') || ''}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getBirthCertificateList: PropTypes.instanceOf(Function).isRequired,
  createBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
